module.exports = __webpack_public_path__ + "static/media/blob1.75d9dc18.svg";